import Image from "../../F7/Image";
import React, { FC, useCallback } from "react";
import usePermissions from "../../../../hooks/usePermissions";
import { ImageObject } from "../../../../hooks/database/types/inventories";

const ImageItem: FC<{ index: number; onImageTrashcanClick: () => void; onClick: () => void; image: ImageObject }> = (props) => {
  const { canDeleteImage } = usePermissions();

  const handleRemoveClick = useCallback(() => {
    props.onImageTrashcanClick();
  }, [props]);

  return (
    <li>
      <div className="item-content">
        <div className="item-media" onClick={props.onClick}>
          <Image
            src={props.image}
            style={{
              borderRadius: 3,
              width: 120,
              minHeight: 90,
            }}
          />
        </div>
        <div className="item-inner">
          <div
            className="item-title"
            style={{
              width: "85%",
              float: "left",
            }}
          ></div>
          {canDeleteImage ? (
            <div className="item-after">
              <label
                className="label-switch"
                style={{
                  width: "100%",
                  float: "right",
                  marginTop: 23,
                }}
              >
                <i
                  className="fa fa-trash-o"
                  style={{
                    float: "right",
                    fontSize: 35,
                  }}
                  onClick={handleRemoveClick}
                ></i>
              </label>
            </div>
          ) : null}
        </div>
      </div>
    </li>
  );
};

export default ImageItem;
